import { serializeCookie } from '../../utils/cookie';
export const appendSetCookieHeaders = (headers, cookies, setCookieOptions) => {
    for (const { name, value } of cookies) {
        headers.append('Set-Cookie', serializeCookie(name, value, setCookieOptions));
    }
};
